import { secondAxios } from "../../../../../../api/axios";

export const getMaterialMasterData = async () => {
  const response = await secondAxios.get(`/material-record`);
  // console.log({ response });
  return response.data;
};
